import PaginateModel from "@/model/paginate";
import api from "./api";
import MCartCustomer, { MCartCustomerDTO } from "@/model/mCartcustomer";

interface AdminCustomerList {
  list: MCartCustomer[];
  paginate: any;
}

class AdminCustomerIdApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAdminCustomerList(query): Promise<AdminCustomerList> {
    const response = await this.getHttp().get<any>("admin-customer", {
      params: query,
    });
    const list: MCartCustomer[] = [];
    const result = response.data.data;

    result.data.map((item: MCartCustomerDTO) =>
      list.push(new MCartCustomer(item))
    );
    // const paginate = new PaginateModel(response.data.pagination);
    const paginate = new PaginateModel({
      page: result.pagination.current_page,
      pageCount: result.pagination.last_pages,
      start: result.pagination.current_page,
      end: result.pagination.last_pages,
      count: result.pagination.total,
    });
    return {
      list: list,
      paginate: paginate,
    };
  }
}
export default new AdminCustomerIdApi();
